import { render, staticRenderFns } from "./supplierNews.vue?vue&type=template&id=3685b226&scoped=true&"
import script from "./supplierNews.vue?vue&type=script&lang=js&"
export * from "./supplierNews.vue?vue&type=script&lang=js&"
import style0 from "./supplierNews.vue?vue&type=style&index=0&id=3685b226&scoped=true&lang=css&"
import style1 from "./supplierNews.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685b226",
  null
  
)

export default component.exports